if (!customElements.get('scrolling-banner')) {
    function initLazyScript(element, callback, threshold = 500) {
        if ('IntersectionObserver' in window) {
          const io = new IntersectionObserver((entries, observer) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                if (typeof callback === 'function') {
                  callback();
                  observer.unobserve(entry.target);
                }
              }
            });
          }, { rootMargin: `0px 0px ${threshold}px 0px` });
      
          io.observe(element);
        } else {
          callback();
        }
      }
    const ScrollingBanner = class extends HTMLElement {
      constructor() {
        super();
        window.initLazyScript(this, this.init.bind(this));
      }
  
      init() {
        // Transforms can confuse lazy loading in browsers, so we coordinate loading here
        // Load all countdown timers
        customElements.whenDefined('countdown-timer').then(() => {
          this.querySelectorAll('countdown-timer').forEach((el) => el.init());
        });
  
        // Load all images
        this.querySelectorAll('img[loading="lazy"]').forEach((el) => {
          el.loading = 'eager';
        });
  
        // After fonts have loaded
        document.fonts.ready.then(() => this.querySelector('.marquee').classList.add('marquee--animate'));
      }
    };
  
    window.customElements.define('scrolling-banner', ScrollingBanner);

    let banner = document.querySelector('.scroll-banner_rocket')
    let button = document.querySelector('.close-scroll')
    button.addEventListener('click', () => {
        banner.classList.add('hidden')
    })
  }
  
